// FV
/*
$('.js-fv-slider').slick({
    autoplay: true,
    autoplaySpeed: 7000,
    speed: 1000,
    arrows: false,
    dots: true,
    dotsClass: 'p-fv__dots slick-dots',
    infinite: true,
    pauseOnHover: true,
});
*/

// ランキング
$('.js-ranking-slider').each(function () {
    const $slider = $(this);
    const $progress = $('.js-ranking-progress');

    function updateProgress(slick, currentSlide = 0) {
        const slideCount = slick && slick.slideCount ? slick.slideCount : 1;
        const progress = slideCount <= 1 ? 100 : ((currentSlide + 1) / slideCount) * 100;
        $progress.css('width', `${progress}%`);
    }

    $slider.on('init afterChange', function (event, slick, currentSlide) {
        updateProgress(slick, currentSlide || 0);
    });

    $slider.slick({
        arrows: false,
        dots: false,
        infinite: false,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 2,
        slidesPerRow: 3,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    rows: 2,
                    slidesPerRow: 2,
                },
            },
            {
                breakpoint: 401,
                settings: {
                    rows: 2,
                    slidesPerRow: 2,
                },
            },
        ],
    });
});
